import { useEffect, useRef, useState } from "react";
import { RefreshCw } from "lucide-react";
import { refreshApp } from "@/lib/api";

const PULL = 80;
const skip = (el) => el?.closest?.('[role="dialog"], [data-no-ptr], input, textarea, select, .overflow-y-auto, .overflow-auto');

// Phones: pull down from the top of any screen to reload it from the server.
export default function PullToRefresh() {
  const [dy, setDy] = useState(0);
  const start = useRef(null);
  useEffect(() => {
    if (!window.matchMedia?.("(pointer: coarse)").matches) return undefined;
    const down = (e) => { start.current = window.scrollY <= 0 && !skip(e.target) ? e.touches[0].clientY : null; };
    const move = (e) => {
      if (start.current == null) return;
      const d = e.touches[0].clientY - start.current;
      if (d <= 0 || window.scrollY > 0) { setDy(0); return; }
      setDy(Math.min(PULL * 1.4, d * 0.5));
    };
    const up = () => {
      setDy((d) => { if (d >= PULL) refreshApp(); return 0; });
      start.current = null;
    };
    window.addEventListener("touchstart", down, { passive: true });
    window.addEventListener("touchmove", move, { passive: true });
    window.addEventListener("touchend", up);
    return () => { window.removeEventListener("touchstart", down); window.removeEventListener("touchmove", move); window.removeEventListener("touchend", up); };
  }, []);
  if (!dy) return null;
  return (
    <div className="pointer-events-none fixed inset-x-0 top-0 z-[62] flex justify-center" style={{ transform: `translateY(${dy}px)` }} data-testid="pull-to-refresh">
      <span className={`flex h-9 w-9 items-center justify-center rounded-full bg-white shadow-lg ring-1 ring-slate-200 ${dy >= PULL ? "text-[#0053DA]" : "text-slate-400"}`}>
        <RefreshCw className="h-4 w-4" style={{ transform: `rotate(${dy * 3}deg)` }} />
      </span>
    </div>
  );
}
